import { PostHeaderElement } from '@components/Post';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

interface Props extends StyleProps, TestIdProps {
  contents: PostHeaderElement[];
  active?: string;
  onItemClick?: (itm: PostHeaderElement) => void;
}

export const PostTableOfContents: FC<Props> = ({ className, style, testId, contents, active, onItemClick }) => {
  if (!contents || !contents.length) return null;

  const handleItemClick = (itm: PostHeaderElement) => () => {
    onItemClick && onItemClick(itm);
  };

  const renderItem = (itm: PostHeaderElement) => {
    const { id, text, subitems } = itm;
    const selected = active === id;
    return (
      <li key={id} className="mb-3 relative">
        {selected && <div className="absolute -left-8 bg-ocean-blue rounded-lg" style={{ width: 6, height: 30 }} />}
        <a
          className={mc('underline text-ocean-blue font-bold', 'hover:text-accent-orange  hover:underline')}
          href={`#${id}`}
          onClick={handleItemClick(itm)}
        >
          {text}
        </a>
        {subitems && subitems.length > 0 && (
          <ul className="list-disc list-inside" style={{ textIndent: '-1.4em', paddingLeft: '1.4em' }}>
            {subitems.map(renderSubItem)}
          </ul>
        )}
      </li>
    );
  };

  const renderSubItem = (itm: PostHeaderElement) => {
    const { id, text } = itm;
    const selected = active === id;
    return (
      <li
        key={id}
        className={mc(
          'pl-8 relative',
          'underline text-accent-blue',
          'hover:text-accent-orange hover:underline',
          // selected ? 'font-bold' : 'font-medium',
        )}
      >
        {selected && <div className="absolute -left-8 top-0 bg-accent-blue rounded-lg" style={{ width: 6, height: 30 }} />}
        <a href={`#${itm.id}`} onClick={handleItemClick(itm)}>
          {text}
        </a>
      </li>
    );
  };

  return (
    <div data-testid={testId} className={mc('hidden lg:block', className)} style={style}>
      <h6 className="block mb-4 font-bold text-xl leading-6 px-8 font-sans mt-0">Table of Contents</h6>
      <ul className="px-8 relative">{contents.map(renderItem)}</ul>
    </div>
  );
};

export default PostTableOfContents;
